export default __webpack_public_path__ + "171f5eb468cb71cb0215a6f44eccdbd8.svg";